import { ElIcon, ElPagination, ElInput, ElAffix } from "element-plus";
import innerAPP from "./../innerAPP";
import App from './App';
const vm = innerAPP(App);
vm.use(ElIcon).use(ElPagination).use(ElInput).use(ElAffix);
vm.mount('#app');